module.exports = __webpack_public_path__ + "static/media/Empty.94acd601.jpg";